import cn from 'classnames'

import s from './Button.scss'

const Button = ({ onClick, children, isDisabled, isPrimary, isSecondary, cy, id }) => (
  <button
    id={id}
    data-cy={cy}
    onClick={() => onClick && onClick()}
    className={cn(s.button, { [s.secondary]: isSecondary, [s.primary]: isPrimary })}
    disabled={isDisabled}
  >
    {children}
  </button>
)

export default Button
